export class SerieFiscal {
  static get PROPIEDADES_EXPORTAR() {
    return [
      { value: "IdSec", label: "Id" },
      { value: "TipoDesc", label: "Tipo" },
      { value: "Fijo", label: "Fijo" },
      { value: "InicioSerie", label: "Inicio de Serie" },
      { value: "FinSerie", label: "Fin de Serie" },
      { value: "ActualSerie", label: "Ultima Secuencia Utilizada" },
      { value: "FechaExpiracion", label: "Fecha Expiración" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Usuario Creación" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Usuario Actualización" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
    ]
  }
}